import { render } from "./LogoutView.vue?vue&type=template&id=5e5d81ec"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__